<script>
export default {
  props: {
    clientDisabledMessage: {
      type: String,
      default: "",
    },
  },
};
</script>

<template>
  <eg-b-container class="mt-3">
    <eg-b-alert variant="warning" show>
      <p class="mb-0">
        {{ clientDisabledMessage }}
      </p>
    </eg-b-alert>
  </eg-b-container>
</template>
